<div class="tw-p-4 md:tw-p-8">
  <div class="tw-flex tw-items-center tw-gap-2 tw-mb-6">
    <!-- Hamburger menu for mobile -->
    <button
      class="toggle-sidenav-btn tw-bg-gray-800 tw-p-2 tw-rounded tw-text-white hover:tw-bg-gray-700 @mdx:tw-hidden tw-mr-2 tw-h-10"
      (click)="toggleThinSidenav()"
      aria-label="Open menu"
      *ngIf="isSmallScreen$ | async">
      <svg
        class="tw-w-6 tw-h-6"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
    <h1 class="tw-text-2xl tw-font-bold tw-text-gray-800 dark:tw-text-gray-100 tw-my-0">
      API Keys
    </h1>

    <!-- Org ID -->
    <div
      *ngIf="org"
      (click)="copyOrgId()"
      class="tw-text-base tw-text-dark-light-dynamic dark:tw-bg-gray-800 badge-md-light tw-flex tw-items-center tw-cursor-copy tw-ml-4">
      Org ID:
      <span
        class="font-code-pro tw-text-sm tw-rounded tw-px-1 tw-py-0.5 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-select-all">
        {{org.id}}
      </span>
      <mat-icon
        class="tw-text-gray-500 dark:tw-text-gray-300 tw-cursor-pointer tw-text-sm tw-w-[unset] tw-h-[unset]">
        content_copy
      </mat-icon>
    </div>
  </div>

  <app-team-api-keys *ngIf="org" [canAdmin]="canAdmin" [org]="org"></app-team-api-keys>
</div>
